import React from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";

import { store, history } from "../configureStore";
import App from "./App";

// const store = configureStore();

const Root = () => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>
);

export default Root;



// WEBPACK FOOTER //
// ./src/containers/Root.js